import './App.css';

import useReveal from './hooks/useReveal';
import useScrollDriver from './hooks/useScrollDriver';

import Nav from './components/Nav';
import Hero from './components/Hero';
import Manifiesto from './components/Manifiesto';
import Servicios from './components/Servicios';
import Galeria from './components/Galeria';
import Proceso from './components/Proceso';
import Sobre from './components/Sobre';
import Datos from './components/Datos';
import Preguntas from './components/Preguntas';
import Contacto from './components/Contacto';
import Pie from './components/Pie';

export default function App() {
  useScrollDriver();
  useReveal();

  return (
    <>
      <div className="avance" aria-hidden="true" />
      <a className="saltar" href="#servicios">
        Ir al contenido
      </a>

      <Nav />

      <main>
        <Hero />
        <Manifiesto />
        <Servicios />
        <Galeria />
        <Proceso />
        <Sobre />
        <Datos />
        <Preguntas />
        <Contacto />
      </main>

      <Pie />
    </>
  );
}
